const ToolboxFilter = (target) => {
  const closeFilter = (e, el) => {
    e.preventDefault()
    document.body.classList.remove('sidebar-opened')
    el.querySelector('.toolbox__sidebar').classList.remove('opened')
  };

  const openFilter = (e, el) => {
    e.preventDefault()
    document.body.classList.add('sidebar-opened')
    el.querySelector('.toolbox__sidebar').classList.add('opened')
  };

  $('body').find(target)
    .each((_, el) => {
      $(el).find('.toolbox__sidebar__close').on('click', e => closeFilter(e, el))
      $(el).find('.toolbox__sidebar__open').on('click', e => openFilter(e, el))
    });
}

export default ToolboxFilter;



// WEBPACK FOOTER //
// ./scripts/components/ToolboxFilter.js